// extracted by mini-css-extract-plugin
export default {"btn_autorenew":"style_btn_autorenew__cU6Hl"};